<template>
  <div
    class="cursor-pointer"
    tabindex="0"
    @click="open = true"
    @keydown="e => keyHandler(e, [], () => open = true)"
  >
    <slot name="button" />
  </div>

  <div
    v-if="open"
    class="fixed inset-0 z-10 h-screen w-screen overflow-hidden bg-neutral-500/50 transition-opacity"
  />
  <transition
    enter-active-class="transition duration-500 ease-in-out"
    leave-active-class="transition duration-500 ease-in-out"
    enter-from-class="translate-x-full"
    enter-to-class="translate-x-0"
    leave-from-class="translate-x-0"
    leave-to-class="translate-x-full"
  >
    <SfDrawer
      ref="drawerRef"
      v-model="open"
      placement="right"
      class="z-20 flex w-[500px] flex-col bg-white p-4 mobile:w-full"
      :class="{ '!p-0': noMargin }"
    >
      <header
        v-if="title"
        class="flex items-center justify-between border-b pb-4"
        :class="{ '!p-4': noMargin }"
      >
        <h3 class="text-neutral-700">
          {{ $t(title) }}
          <slot name="title" />
        </h3>
        <KikButton
          square
          variant="tertiary"
          @click="open = false"
        >
          <SfIconClose class="fill-neutral-500 text-neutral-500" />
        </KikButton>
      </header>
      <div
        class="h-full overflow-y-auto py-4"
        :class="{ '!py-0': noMargin }"
      >
        <slot name="content" />
      </div>
      <slot
        name="footer"
        :close="() => open = false"
      >
        <footer class="mt-auto border-t pt-4">
          <KikButton
            class="w-full"
            @click="open = false"
          >
            {{ $t('Close') }}
          </KikButton>
        </footer>
      </slot>
    </SfDrawer>
  </transition>
</template>

<script lang="ts" setup>
import {
  SfDrawer,
  SfIconClose,
  useTrapFocus,
} from '@storefront-ui/vue';
import keyHandler from '~/helpers/a11y/keyHandler';

interface Props {
  title?: string;
  noMargin?: boolean;
}

defineProps<Props>();
const emit = defineEmits(['onVisibilityChange']);

const open = ref(false);
const drawerRef = ref();

useTrapFocus(drawerRef, { activeState: open });

watch(open, (value) => {
  emit('onVisibilityChange', value);
});
</script>
